var GenericPesquisaProps = /** @class */ (function () {
    function GenericPesquisaProps() {
    }
    return GenericPesquisaProps;
}());
export { GenericPesquisaProps };
